export default __webpack_public_path__ + "static/media/SourceSansPro-Black.f4dfcc18.ttf";